<template>
  <div class="sticky-page-header">
    <div class="header-left">
      <button
        class="header-back-btn"
        type="button"
        :disabled="backDisabled"
        @click="handleBack"
      >
        <ion-icon :icon="chevronBackOutline" class="back-icon" />
      </button>
      <slot name="title">
        <span v-if="title" class="header-title">{{ title }}</span>
      </slot>
    </div>
    <slot name="right" />
  </div>
</template>

<script>
import { IonIcon } from '@ionic/vue';
import { useRouter } from 'vue-router';
import { chevronBackOutline } from 'ionicons/icons';

export default {
  name: 'StickyPageHeader',
  components: { IonIcon },
  props: {
    title: { type: String, default: '' },
    backHref: { type: String, default: '' },
    backDisabled: { type: Boolean, default: false },
  },
  emits: ['back'],
  setup(props, { emit }) {
    const router = useRouter();

    const handleBack = () => {
      if (props.backDisabled) return;
      if (props.backHref) {
        router.push(props.backHref);
        return;
      }
      emit('back');
    };

    return {
      chevronBackOutline,
      handleBack,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/profile-editor.scss';

.sticky-page-header {
  @include sticky-modal-header;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
}

.header-back-btn {
  @include modal-back-btn;
}

.back-icon {
  color: #ffcc00;
  font-size: 24px;
}

.header-title {
  font-size: 24px;
  font-weight: 400;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
